<template>
  <div class="limiter" v-if="id">
    <div class="image">
      <img src="../assets/logo/logo.png" alt="Logo" />
    </div>

    <div class="container-login100">
      <div class="wrap-login100">
        <div class="form-summary">
          <h2 style="color: #3A6898">Payment Details</h2>
          <div class="form-group">
            <p class="summary-item"><strong>Payment:</strong> {{ payment }}</p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>SaleTotal:</strong> {{ saletotal }}</p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>Discount:</strong> {{ discount }}%</p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>Amount To Pay:</strong> {{ amountToPay ? amountToPay.toFixed(2) : '0.00' }}</p>
          </div>
        </div>
      </div>
    </div>

    <h3>Select Payment Method</h3>
    <div class="payment-methods">
      <button type="button" class="login100-form-btn btn-file-input" @click="attach" ref="scrollToBottom">
        <img src="../assets/img/bank.png" alt="Bank Icon" class="button-icon" /> Bank / EFT
      </button>
      <button type="button" class="login100-form-btn btn-file-input" @click="payByKazang">
        <img src="../assets/img/Kazang.png" alt="Mobile Money Icon" class="button-icon" /> Mobile Money
      </button>
    </div>

    <div class="buttons">
      <div class="payment-option">
        <span class="payment-label">Takes 2 Days to Process</span>
        <div class="file-input-container">
          <!-- Intentionally left blank -->
        </div>
      </div>

      <div class="payment-option" v-if="!file">
        <span class="payment-label">Instant Payment</span>
      </div>
    </div>

    <div class="card" v-if="showattach">
      <div class="card-body">
        <div class="text-center mb-3">
          <h5>Payment Reference: {{ paymentReference }}</h5>
          <button class="btn btn-sm btn-secondary" @click="copyReference">
            Copy Reference
          </button>
        </div>

        <span>
          <span v-html="message"></span>
          <br /><br />
          <strong>Note:</strong> When making a manual payment, it's important to use the correct reference to ensure your payment is applied to your account and to avoid delays. Double-check the reference number before making your manual payment. If you have any questions, please reach out to us.
        </span>
      </div>

      <div class="w-100 d-flex justify-content-center align-items-center">
        <span v-if="file" class="payment-label" @click="preview" style="cursor: pointer;"><strong>Click to Preview</strong></span>
      </div>

      <div>
        <!-- File input for proof of payment -->
        <div class="file-input-container mb-2">
          <input
              id="file-pacraCert"
              class="input100"
              type="file"
              name="pop"
              @change="handleFileChange($event)"
              accept=".pdf,image/*"
          />
          <label for="file-pacraCert" class="btn-file-input">
            {{ pop ? pop : 'Attach proof of payment' }}
          </label>
        </div>

        <div class="w-100 d-flex justify-content-center align-items-center mb-2">
          <button v-if="file" style="background-color: #3A6898" class="btn btn-primary" @click="submit">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentDetails',
  data() {
    return {
      id: this.$route.query.id,
      payment: 'Full payment',
      discount: '',
      amountToPay: 0,
      saletotal: '',
      pop: '',
      file: null,
      message:'',
      paymentReference:'',
      showattach: false,
    };
  },

  created() {
    this.fetchData();
  },

  watch: {
    '$route.query.id': function(newId) {
      this.id = newId;
    },
  },
  methods: {
    async fetchData() {
      this.$store.commit(`setLoadingState`, true);
      return this.$store.dispatch('fetchDebtor',this.id)
          .then((data)=>{
            this.saletotal = data.quoteTotal;
            this.discount = data.discountRate;
            this.amountToPay = data.paymentTotal;
            this.message = data.message.replaceAll("\n","<br>");
            this.paymentReference = data.paymentReference;
          })
          .finally(()=> this.$store.commit(`setLoadingState`, false))
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.file = file;
        this.pop = file.name;
      }
    },

    async submit() {
      const fileBase64 = this.file ? await this.fileToBase64(this.file) : '';
      let id = this.$route.query.id;

      const payload = {
        amount: this.amountToPay,
        Payment_ID: id,
        FileName: this.pop,
        type: 'QUOTE',
        File: fileBase64,
      };

      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('popValidation',payload)
          .then(()=> {
            responses.showSuccess(`Your information has been submitted!`)
            this.showattach = false;
            return window.open("/success",`_self`);
          })
          .finally(()=>  this.$store.commit('setLoadingState', false))
    },

    async payByKazang(){
      let ref = {
        quoteNumber: this.id,
        amount:this.amountToPay,
        discountAmount:this.saletotal - this.amountToPay
      }
      let encodedRef = window.btoa(JSON.stringify(ref));
      const payload = {
        amount:   this.amountToPay,
        Service_Description: `Payment on quote: ${this.id}`,
        Client_Refrence: encodedRef,
        Cancel_Url: 'https://zero.chrilantech.com/test-failed',
        Sucess_Url: 'https://synergy.abc.co.zm/success',
      }
      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('createTransaction', payload)
          .finally(()=>  this.$store.commit('setLoadingState', false))
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    async copyReference(){
      copy(this.paymentReference)
      responses.showSuccess('Reference copied')
    },

    async attach() {
      this.showattach = true;
      this.$nextTick(() => {
        if (this.$refs.scrollToBottom) {
          this.$refs.scrollToBottom.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
    handleClick(type) {
      if (type === 'bank') {
        this.$router.push({ path: '/bank-payment', query: { id: this.id } });
      } else if (type === 'mobile') {
        this.$router.push({ path: '/mobile-payment', query: { id: this.id } });
      }
    },
    async preview() {
      try {
        const fileBase64 = this.file ? await this.fileToBase64(this.file) : '';
        const fileType = this.file ? this.file.type : ''; // Check file type (e.g., 'image/png', 'application/pdf')

        const newWindow = window.open('', '_blank');
        if (!newWindow) {
          throw new Error('Failed to open new window. It might be blocked by the browser.');
        }

        if (fileType.startsWith('image/')) {
          // Handle image preview
          newWindow.document.write(`
        <html>
            <head><title>Image Preview</title></head>
            <body style="text-align: center; padding: 20px;">
                <h1>Image Preview</h1>
                <img src="${fileBase64}" style="max-width: 100%; height: auto;" />
            </body>
        </html>
      `);
        } else if (fileType === 'application/pdf') {
          // Handle PDF preview
          newWindow.document.write(`
        <html>
            <head><title>PDF Preview</title></head>
            <body style="text-align: center; padding: 20px;">
                <h1>PDF Preview</h1>
                <embed src="${fileBase64}" type="application/pdf" width="100%" height="600px" />
            </body>
        </html>
      `);
        } else {
          throw new Error('Unsupported file type for preview.');
        }

        newWindow.document.close();
      } catch (error) {
        console.error('Error previewing file:', error.message);
      }
    }

  }
}
</script>


<style scoped>
.buttons {
  flex-wrap: wrap; /* Allows items to wrap onto multiple lines */
  max-width: 600px; /* Adjusted to give more space for items */
  margin: 30px auto; /* Center the container horizontally */
  display: flex;
  justify-content: space-between; /* Space items evenly */
  align-items: center; /* Center items vertically */
  gap: 30px; /* Increased space between payment options */


}

.payment-option {
  display: flex;
  flex-direction: column; /* Stack the label and button/file input vertically */
  align-items: center; /* Center items horizontally */
}

.payment-label {
  font-size:1rem; /* Smaller font size for labels */
  margin-bottom: 15px; /* Increased space between label and button/file input */
}

.file-input-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center file input and label */
}

.input100 {
  min-width: 200px;
  display: none; /* Hide the actual file input */
}

.payment-methods {
  display: flex;
  gap: 10px; /* Adds space between the buttons */
  justify-content: center;
  margin-left: 100px;

}

/* Consolidated button style */
.btn-common {
  width: 300px; /* Adjusted to match the button size from the second image */
  height: 45px; /* Adjusted height */
  padding: 12px 20px; /* Increased padding for better appearance */
  background-color: #3A6898; /* Primary button background color */
  color: white; /* Button text color */
  border: none; /* Remove default button border */
  border-radius: 5px; /* Make buttons slightly rounded */
  cursor: pointer; /* Pointer cursor for clickable buttons */
  transition: background-color 0.3s ease, transform 0.2s; /* Smooth hover transition */
  text-align: center;
  display: flex;
  align-items: center; /* Align content within the button */
  justify-content: center;
  gap: 10px; /* Gap between text and icons */
}

.login100-form-btn, .btn-file-input, .submit-btn {
  composes: btn-common; /* Apply common button styles */
}

.button-icon {
  width: 20px; /* Adjust the size of the icons */
  height: 20px;
}

h3 {
  text-align: center; /* Centers the text horizontally */
  margin-top: 20px; /* Add some space above if necessary */
  margin-bottom: 20px; /* Add some space below if necessary */
  font-size: 1.5rem; /* Adjust the font size as needed */
  font-weight: bold; /* Optional: makes the text bold */
  color: #3A6898; /* Optional: Change the color if desired */
}

.file-input-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center the content horizontally */
  margin-top: 20px; /* Add space from the top */
}

.pay-btn {
  width: 300px; /* Adjust the width of the button */
  height: 45px; /* Set the button height */
  padding: 12px 20px; /* Add padding for better appearance */
  background-color: #3A6898; /* Primary button background color */
  color: white; /* Button text color */
  border: none; /* Remove default button border */
  border-radius: 5px; /* Make buttons slightly rounded */
  cursor: pointer; /* Pointer cursor for clickable buttons */
  transition: background-color 0.3s ease; /* Smooth hover transition */
  text-align: center;
  display: flex;
  align-items: center; /* Align content within the button */
  justify-content: center; /* Center the content horizontally */
  gap: 10px; /* Gap between text and icons */
  margin-top: 20px; /* Add space from the top */
  margin-left: 620px;
}

.btn-common {
  width: 300px; /* Width of the button */
  height: 45px; /* Set the button height */
  padding: 12px 20px; /* Add padding for better appearance */
  background-color: #3A6898; /* Primary button background color */
  color: white; /* Button text color */
  border: none; /* Remove default button border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor for clickable buttons */
  transition: background-color 0.3s ease; /* Smooth hover transition */
  text-align: center;
  display: flex;
  align-items: center; /* Center the content vertically */
  justify-content: center; /* Center the content horizontally */
  gap: 10px; /* Space between icon and text (if any) */
  margin-top: 20px; /* Add space from the top */
}

/* Apply common styles for the submit button */
.submit-btn {
  composes: btn-common;
  width: 300px;
  margin-left: 620px;
  margin-top: 10px;


}

/* Media query for screens 376px or less */
@media (max-width: 376px) {
  .submit-btn {
    margin-left: 50px; /* Adjust margin-left for small screens */
  }
}

@media (max-width: 561px) {
  .wrap-login100 {
    max-width: 300px; /* Maximum width on smaller screens */
    min-width: 200px;  /* Minimum width */
    width: 100%; /* Allow the container to be responsive */
  }
}
@media (max-width: 376px) {
  .pay-btn {
    margin-left: 20px;
  }
}

@media (max-width: 561px) {
  .wrap-login100 {
    max-width: 300px; /* Maximum width on smaller screens */
    min-width: 200px; /* Minimum width */
    width: 100%; /* Allow the container to be responsive */
  }
}

</style>





